import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";
import {
  ErrorDetails,
  TransportTypeConfigRequestDTO,
  TransportTypeEditRequestDTO
} from "app/services/authentication/connection/interfaces/apiInterfaces";
import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";

export class UpdateTransportTypeConfigCommand extends IRequestCommand<
  ICommandResponse,
  ErrorDetails,
  IUpdateTransportTypeEditCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.PUT;
  override _commandUrl = 'carriers/{carrierId}/transportTypes/{transportTypesId}/config';
  public override setParameters(parameters: IUpdateTransportTypeEditCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{transportTypesId}',
      parameters.transportTypesId.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{carrierId}',
      parameters.carrierId.toString()
    );
    this._commandBody = parameters;
  }
}

export interface IUpdateTransportTypeEditCommandParameters
  extends TransportTypeEditRequestDTO,
    ICommandParameters {
  transportTypesId: string;
  carrierId: string;
}
